module.exports = __webpack_public_path__ + "static/media/tempTemplate1.f279627b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Templates/tempTemplate1.png
// module id = 494
// module chunks = 0